<template>
  <div class="personalization">
    <div class="content">
      <a-spin :spinning="loading">
        <div class="operateContent">
          <div class="operateLeft">
            <div class="menuTitle">
              <span>系统消息个性化</span>
            </div>
            <a-menu
              v-if="systemMessageList.length"
              :selectedKeys="[SelectedId]"
              :defaultOpenKeys="[SelectedId]"
              style="width: 200px; margin: 0 auto"
              mode="inline">
              <template v-for="Item in systemMessageList">
                <a-menu-item :key="Item.customizationId" @click="handleClick(Item)">
                  <span class="hidden_text_one">{{ Item.clientName || '--' }}</span>
                </a-menu-item>
              </template>
            </a-menu>
            
            <div class="selectEnterprise">
              <div class="menuTitle">
                <span class="menuTitle-left">业务消息个性化</span>
                <div class="addMenu" @click="addBusinessMessage">
                  <a-icon type="plus" />
                  <span>新增</span>
                </div>
              </div>  
            </div>
            <a-menu
              v-if="businessMessageList.length"
              :selectedKeys="[SelectedId]"
              :defaultOpenKeys="[SelectedId]"
              style="width: 200px; margin: 0 auto"
              mode="inline"
            >
              <template v-for="Item in businessMessageList">
                <a-menu-item :key="Item.customizationId" @click="handleClick(Item)">
                  <span class="hidden_text_one">{{ Item.tenantName || '--' }}</span>
                  <span class="oper_2">
                    <a-dropdown destroyPopupOnHide>
                      <div class="cardItemMenu">
                        <a-icon type="more" style="font-size: 18px;transform: rotate(90deg)" />
                      </div>
                      <a-menu slot="overlay">
                        <a-menu-item style="height: 32px;padding: 0;">
                          <a-button style="width: 100%;height: 32px; color: #FF3B3B;text-align: left" type="link" @click="delIndividuation(Item)">
                            删除配置
                          </a-button>
                        </a-menu-item>
                      </a-menu>
                    </a-dropdown> 
                  </span>
                </a-menu-item>
              </template>
            </a-menu>
          </div>
          <div class="operateRight" v-if="individuationRecord && individuationRecord.customizationId">
            <div class="tenantInfo">
              <div class="tName">
                <span v-if="individuationRecord.isSystem"> {{ individuationRecord.clientId || '--' }}</span>
                <span v-else>{{ individuationRecord.tenantName || '--' }}</span>
              </div>
              <div class="tenantId">
                <span v-if="individuationRecord.isSystem">应用id：{{ individuationRecord.clientId || '--' }}</span>
                <span v-else>租户id：{{ individuationRecord.tenantId || '--' }}</span>
              </div>
            </div>

            <div class="formContent">
              <a-form :form="form">
                <div class="formItemTitle">邮箱服务配置</div>
                <a-form-item
                  label="是否使用SSL加密"
                  :label-col="{ span: 2,  style: { width: '130px' }}"
                  :wrapper-col="{ span: 19 }"
                >
                  <a-radio-group
                    name="radioGroup"
                    v-model="individuationRecord.smtp.enableSSL"
                    :disabled = !isModify
                  >
                    <a-radio :value="true">是</a-radio>
                    <a-radio :value="false">否</a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item
                  label="smtp服务器域名"
                  :label-col="{ span: 2,style: { width: '130px' } }"
                  :wrapper-col="{ span: 19 }"
                >
                  <a-input
                    placeholder="请输入smtp服务器域名"
                    v-model="individuationRecord.smtp.host"
                    :disabled = !isModify
                  ></a-input>
                </a-form-item>
                <a-form-item
                  label="smtp服务器端口"
                  :label-col="{ span: 2, style: { width: '130px' } }"
                  :wrapper-col="{ span: 19 }"
                >
                  <a-input
                    placeholder="请输入smtp服务器端口"
                    v-model="individuationRecord.smtp.port"
                    :disabled = !isModify
                  ></a-input>
                </a-form-item>
                <a-form-item
                  label="发送人的邮箱账号"
                  :label-col="{ span: 2,style: { width: '130px' } }"
                  :wrapper-col="{ span: 19 }"
                >
                  <a-input
                    placeholder="请输入发送人的邮箱账号"
                    v-model="individuationRecord.smtp.username"
                    :disabled = !isModify
                  ></a-input>
                </a-form-item>
                <a-form-item
                  label="发送人的邮箱密码"
                  :label-col="{ span: 2,style: { width: '130px' } }"
                  :wrapper-col="{ span: 19 }"
                >
                  <a-input
                    placeholder="请输入发送人的邮箱密码"
                    v-model="individuationRecord.smtp.password"
                    :disabled = !isModify
                  ></a-input>
                </a-form-item>
                <a-form-item
                  label="发送人名称"
                  :label-col="{ span: 2,style: { width: '130px' } }"
                  :wrapper-col="{ span: 19 }"
                >
                  <a-input
                    placeholder="请输入发送人名称"
                    v-model="individuationRecord.smtp.personalAlias"
                    :disabled = !isModify
                  ></a-input>
                </a-form-item>
                <div class="formItemTitle">短信签名</div>
                <div class="subtitle" style="margin-bottom: 5px;">亿美软通的短信模板申请需要和签名绑定，所以模板申请成功后不能替换签名。</div>
                <a-table
                  :columns="SMScolumns"
                  :data-source="individuationRecord.smsDTO || []"
                  :pagination="false"
                  bordered
                  style="width: 1000px;"
                >
                  <!-- 渠道输入框 -->
                  <template slot="SMSIndex" slot-scope="text, record, index">
                    <span>{{ index+1 }}</span>
                  </template>
                  <template slot="channelType" slot-scope="text, record, index">
                    <a-select
                      v-model="record.channelType"
                      style="width: 100%"
                      placeholder="请选择渠道"
                      :disabled = !isModify
                    >
                      <a-select-option value="TENCENT_SMS">腾讯云</a-select-option>
                      <a-select-option value="YIMEI">亿美软通</a-select-option>
                    </a-select>
                  </template>

                  <template slot="signatureName" slot-scope="text, record, index">
                    <a-input
                      v-model="record.signatureName"
                      placeholder="请输入签名内容"
                      :disabled = !isModify
                      :maxLength="20"
                    >
                    <template slot="suffix">
                      <span class="count-text">{{ record.signatureName?.length || 0 }}/20</span>
                    </template>
                    </a-input>
                  </template>

                  <!-- 签名状态下拉选择 -->
                  <template slot="status" slot-scope="text, record, index">
                    <a-select
                      v-model="record.status"
                      style="width: 100%"
                      placeholder="请选择签名状态"
                      :disabled = !isModify
                    >
                      <a-select-option :value="1">可用</a-select-option>
                      <a-select-option :value="0">不可用</a-select-option>
                    </a-select>
                  </template>
            
                  <!-- 操作菜单 -->
                  <template slot="action" slot-scope="text, record, index">
                    <a-popconfirm
                      v-if="isModify"
                      title="确定删除吗？"
                      ok-text="确定"
                      cancel-text="取消"
                      @confirm="() => handleDelete(index)"
                    >
                      <a-button type="link" danger>删除</a-button>
                    </a-popconfirm>
                    <a-button type="link" danger v-else disabled>删除</a-button>
                  </template>
                </a-table>
                <a-button icon="plus" style="margin-top: 10px;" @click="addSmsSignature" type="primary" ghost :disabled = !isModify>添加</a-button>

                <!-- <div class="formItemTitle" style="margin-top: 10px;">绑定微信服务号</div>
                <div class="subtitle">成员在服务号可以正常参与流程，接收抄送、消息推送等通知。</div>
                <a-switch checked-children="开" un-checked-children="关" 
                  v-model="individuationRecord.weixinEnabled"
                  :disabled = !isModify
                  style="margin: 5px 0;"/> -->
              </a-form>
            </div>

            <div class="bottomBtn">
              <template  v-if="isModify">
                <a-button @click="isModify = false">取消</a-button>
                <a-button type="primary" style="margin-left: 20px;" @click="handleSave">保存</a-button>
              </template>
              <a-button type="primary" v-else @click="openEdit">编辑</a-button>
            </div>
          </div>
        </div>
      </a-spin>

       <chooseTenant
        title="新增业务消息个性化"
        :visible.sync="addVisible"
        @close="addVisible = false"
        :dataList="individuationData"
        @refresh="refresh"
       >
       </chooseTenant>
    </div>
  </div>
</template>
<script>
import chooseTenant from './components/chooseTenant.vue'
import getScrollHeight from '@/utils/scrollHeight.js'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'personalization',
  inject: ['reload'],
  mixins: [ getScrollHeight ],
  components: {
    chooseTenant,
  },
  data() {
    return {
      individuationData: [],
      sceneId: '',
      loading: false,
      systemMessageList: [], //系统消息列表
      businessMessageList: [], //业务消息个性化
      SelectedId: '', // 选中的个性化ID
      individuationRecord: {}, //选中的个性化
      isModify: false, //编辑
      form: this.$form.createForm(this),
      SMScolumns: [
        {
          title: "",
          dataIndex: "SMSIndex",
          scopedSlots: { customRender: "SMSIndex" },
          width: "50px",
        },
        {
          title: "*渠道",
          dataIndex: "channelType",
          scopedSlots: { customRender: "channelType" },
          width: "150px",
        },
        {
          title: "签名内容",
          dataIndex: "signatureName",
          scopedSlots: { customRender: "signatureName" },
          width: "320px",
        },
        {
          title: "签名状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
          width: "150px",
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          width: "50px",
        },
      ],
      addVisible: false,
    
     
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 新增业务消息
    addBusinessMessage(){
      this.addVisible = true
    },

    // 进入编辑
    openEdit(){
      this.isModify = true
    },
    //保存
    handleSave(){
      const { individuationRecord = {} } = this
      const {
        tenantId = '',
        tenantName = '',
        clientId = '',
        clientName = '',
        weixinEnabled = false,
        smtpDTO = {},
        smsDTO = [],
        customizationId = ''
       } = individuationRecord
       const params = {
          tenantId,
          tenantName,
          clientId,
          clientName,
          weixinEnabled,
          smtpDTO,
          smsDTO,
          customizationId
        }
        this.$api.updateCustomization(params).then((res) => {
          if (res.code === 0) {
            this.$message.success('保存成功')
            this.isModify = false
            this.getCustomizationList(this.sceneId,customizationId)
          }
        }).catch((err) => {
          this.$message.error('保存失败')
          console.log(err, '保存失败')
        })
    },

    // 添加短信签名
    addSmsSignature(){
      if (!this.individuationRecord.smsDTO) {
        this.$set(this.individuationRecord, 'smsDTO', []);
      }
      this.individuationRecord.smsDTO.push({
        channelType: undefined,
        signatureName: '',
        status: undefined,
      })
    },
    // 删除一行
    handleDelete(index) {
      this.individuationRecord.smsDTO.splice(index, 1);
    },

    handleClick(item) {
      this.isModify = false
      this.individuationRecord = null
      this.SelectedId = item.customizationId
      const curItem = this.individuationData.find(fd => fd.customizationId === item.customizationId)
      this.individuationRecord = curItem ? cloneDeep({
        ...curItem,
        smsDTO: curItem.sms || [],
        smtpDTO: curItem.smtp || {},
      }) : {}
    },

    init() {
      this.isModify = false
      this.getCustomizationList(this.sceneId)
    },

    refresh() {
      this.init()
    },

    /* 获取客制化（个性化配置）列表数据 */
    async getCustomizationList(scenarioId,defSelectedId = '') {
      this.loading = true
      this.individuationData = []
      this.systemMessageList = []
      this.businessMessageList = []
      this.SelectedId = ''
      this.individuationRecord = null
      try {
        const { code, data = [] } = await this.$api.getCustomizationList(scenarioId)
        if (code === 0 && Array.isArray(data) && data.length ) {
          this.systemMessageList = data.filter( item => item.isSystem) //系统消息个性化
          this.businessMessageList = data.filter( item => !item.isSystem) // 业务
          this.SelectedId = defSelectedId ? defSelectedId : (this.systemMessageList.length ? this.systemMessageList[0].customizationId : this.businessMessageList[0].customizationId)
          this.individuationData = cloneDeep(data)
          const chooseRecord = data.find(fd => fd.customizationId === this.SelectedId)
          this.individuationRecord = chooseRecord ? {
            ...chooseRecord,
            smsDTO: chooseRecord.sms || [],
            smtpDTO: chooseRecord.smtp || {},
          } : {}
        }
        this.loading = false
			} catch (error) {
        this.loading = false
			}
    },

    /* 删除个性化设置 */
    delIndividuation(record) {
      this.$confirm({
        title: '你确定要删除这条个性化设置吗？',
        onOk: () => {
          this.$api.deleteCustomization(record.customizationId).then((res) => {
            if (res.code === 0) {
              this.$message.success('删除成功')
              this.refresh()
            }
          }).catch((err) => {
            this.$message.error('删除失败')
          })
        },
        onCancel() {},
      })
    }

  },
}
</script>

<style lang="less" scoped>
@import '@/assets/CSS/global.less';
/deep/ .ant-menu-item,
.ant-menu-item-selected {
  .oper_0 {
    position: absolute;
    right: 80px;
  }
  .oper_1 {
    position: absolute;
    right: 45px;
  }
  .oper_2 {
    position: absolute;
    right: 0px;
  }
}
// 去掉右边框
.ant-menu-inline {
  border: none;
}
// 设置子菜单展开样式
/deep/ .ant-menu-submenu-title {
  color: #151515 !important;
  padding-left: 10px !important;
}

// a链接样式
.ant-menu-item a {
  color: #999999;
}
.ant-menu-item a:hover {
  color: #151515;
}
// 选中菜单状态
/deep/ .ant-menu-item-selected {
  position: relative;
  background-color: #ecf4fe !important;
  border-radius: 3px;
  a {
    color: #1890ff !important;
  }
  &::after {
    display: none;
  }
}

.hidden_text_one {
  position: absolute;
  left: 10px;
  width: 120px;
  overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
  text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
  white-space: nowrap; /*文本不换行*/
}

.personalization {
  height: 99%;
  width: 100%;
  display: flex;
  flex-direction: columns;
  justify-content: space-between;
  background: #F0F2F5;
  .content {
    width: 100%;
    background-color: #fff;
    .operateContent{
      display: flex;
      height: 100%;
      .menuTitle {
        height: 60px;
        display: flex;
        align-items: center;
        position: relative;
        justify-content: end;
        span{
          &:first-child {
            position: absolute;
            left: 20px;
            font-weight: 700;
            font-size: 16px;
            text-align: left;
            color: #151515;
            /* 伪类 */
            &::before {
              content: '';
              position: absolute;
              top: 50%;
              left: -15px;
              transform: translateY(-50%);
              width: 4px;
              height: 20px;
              border-radius: 3px;
              background: #1890ff;
            }
          }
        }
      }

      .operateLeft{
        width: 230px;
        height: calc( 100vh - 140px );
        overflow-y: auto;
        margin: 0 20px 10px 0;
        .selectEnterprise{
          margin-top: 10px;
          .addMenu{
            cursor: pointer;
            color: #1890ff;
            padding-right: 10px;
          }
        }
      }
      .operateRight{
        flex: 1;
        position: relative;
        height: calc( 100vh - 140px );
        .tenantInfo{
          height: 70px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          .tName{
            font-size: 16px;
            font-weight: bold;
          }
        }
        .formContent{
          height: calc(100% - 100px);
          overflow-y: auto;
        }
        .bottomBtn{
          position: fixed;
          right: 40px;
          bottom: 40px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
.ant-form-item {
  margin-bottom: 10px;
}
.formItemTitle {
  font-weight: bold;
}
.subtitle{
  font-size: 14px;
}
.count-text {
  font-family: 'PingFangSC';
  font-weight: 400;
  font-size: 13px;
  line-height: 14px;
  text-align: right;
  color: #bebebe;
}
</style>
